<template>
  <!-- Header -->
  <div class="relative bg-bgbb-y pb-10 pt-12">
    <div class="px-2 md:px-4 mx-auto w-full">
      <div>
        <!-- Card stats -->
        <div class="flex flex-wrap">
          <div class="w-full lg:w-6/12 xl:w-3/12 px-4">
            <card-stats
              statSubtitle="GLOBAL BGBB STAKED"
              statTitle="350,897"
              statArrow="up"
              statPercent="3.48"
              statPercentColor="text-green-500"
              statDescripiron=""
              statIconName=""
              statIconColor=""
            />
          </div>
          <div class="w-full lg:w-6/12 xl:w-3/12 px-4">
            <card-stats
              statSubtitle="GLOBAL BGBB SHARES"
              statTitle="2,356"
              statArrow="down"
              statPercent="3.48"
              statPercentColor="text-red-500"
              statDescripiron=""
              statIconName=""
              statIconColor=""
            />
          </div>
          <div class="w-full lg:w-6/12 xl:w-3/12 px-4">
            <card-stats
              statSubtitle="GLOBAL REFERRAL SHARES"
              statTitle="924"
              statArrow="down"
              statPercent="1.10"
              statPercentColor="text-orange-500"
              statDescripiron=""
              statIconName=""
              statIconColor=""
            />
          </div>
          <div class="w-full lg:w-6/12 xl:w-3/12 px-4">
            <card-stats
              statSubtitle="GLOBAL SHARE PRICE"
              statTitle="49,65%"
              statArrow="up"
              statPercent="12"
              statPercentColor="text-green-500"
              statDescripiron=""
              statIconName=""
              statIconColor=""
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CardStats from "@/components/Cards/CardStats.vue";

export default {
  components: {
    CardStats,
  },
};
</script>
